import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import projectsSagas from './projects/saga';
import projectDetailSagas from './projectDetail/saga';

export default function* rootSaga() {
  yield all([authSagas(), projectsSagas(), projectDetailSagas()]);
}
